import { Card, Typography, Box } from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react';

export function QRPalate({ user, qrno, expdate,amount }) {
     
   return (
    <>
       <Card sx={{ p: 1,m:1,background:'#fff', color:'#000',
               boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px',
               maxWidth:'150px', width:'100%' , maxHeight:'auto'  }}>
             <Typography variant='h6' sx={{fontSize:'12px', color:'#333'}}>{qrno || 'N/A'}</Typography>
               <Box sx={{mb:0, pb:0}}>
                    <QRCodeCanvas value={qrno}  sx={{maxWidth:'100px'}} />
               </Box>
                <Typography> ₹ {amount | 'NA'} </Typography>
              </Card>
    </>
  );
}
